import { environment, } from  "@/utils/consts";

const sectionArr = [
  {id: '223061467004929',name: '人工智能',route: '/AI'},
  {id: '223061586542593',name: '电子信息',route: '/electronic-information'},
  {id: '223061720760321',name: '新能源',route: '/new-energy'},
  {id: '223061693497345',name: '航天科技',route: '/physics'},
  {id: '223061632679937',name: '新材料',route: '/new-material'},
  {id: '223061548793857',name: '生物医药',route: '/biology'},
  {id: '223061613805569',name: '光电芯片',route: '/chip'},
  {id: '223061666234369',name: '智能智造',route: '/manufacture'},
  {id: '226357839724545',name: '环保/碳中和',route: '/environment'},
  {id: '223091577913345',name: '气候生态',route: '/climate'},
  {id: '223061852880897',name: '智慧农业',route: '/agriculture'},
  {id: '229682666602497',name: '外贸服装',route: '/clothing'},
  {id: '233424338092033',name: '一缆之事',route: '/glance'},
  {id: '223091131219969',name: '电化学',route: '/electrochemistry'},
  {id: '221461038039041',name: '科技前沿',route: '/frontier'},
  {id: '256073472737281',name: '科技潮品',route: '/fashion'},
  {id: '241241681887233',name: '科技论坛',route: '/forum'},
  {id: '256630665052161',name: '科技设施',route: '/facility'},
  {id: '253016913543169',name: '产业园区',route: '/park'},
  {id: '256676592680961',name: '科技设备',route: '/equipment'},
  {id: '253016710119425',name: '科技人物',route: '/character'},
  {id: '228903872430081',name: '数字AR',route: '/AR'},
  {id: '228143476572161',name: '产业前瞻',route: '/industry-outlook'},
  {id: '226897227218945',name: '政策导向',route: '/policy'},
  {id: '231085843742721',name: '融资创投',route: '/finance-capital'},
  {id: '221461073690625',name: '商业视线',route: '/commerce'},
  {id: '254963810893825',name: '商业案例',route: '/case'},
  {id: '253016760451073',name: '焦点访谈',route: '/focus'},
  {id: '263165694771201',name: '洞见',route: '/insight'},
]

export const judgeMobileHomeUrl = () =>{
  let flag = false
  for (let index = 0; index < sectionArr.length; index++) {
    const element = sectionArr[index];
    if(window.location.href.includes(`keqidao.com${element.route}`)){
      flag = true
      window.location.href = environment === 'uat' ? `https://umobile.keqidao.com/?id=${element.id}` : `https://mobile.keqidao.com/?id=${element.id}`
      break
    }
  }
  return flag
}